<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-2">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/oil-truck.svg" width="" />
                  </div>
                </div>
                <div class="col-md-5 remove-padding-left">
                  <div class="">
                    <h4 class="text-white mobile_text">
                      {{ $t("text.iTankTransactions.title") }}
                    </h4>
                  </div>
                  <div class="mt-5">
                    <h5 class="text-white mt-1 mobile_text_para">
                      {{ $t("text.iTankTransactions.getReports") }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-4 remove-padding-left date__m">
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    color="#370F70"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="full__row_section mt-3">
        <div class="row top_section_row mb-3" style="border-radius: 20px">
          <div class="col-md-8">
            <span>
              {{ $t("text.iTankTransactions.tankReportsOn") }}
              {{ $d(new Date(startDate), "short", this.$root.$i18n.locale) }}
            </span>
          </div>
          <div class="col-md-4 text-right"></div>
        </div>
      </section>

      <section class="products_summary__wrapper pb-3 mt-3">
        <div class="row mt-3">
          <div class="col-md-8 remove-padding-left padding_div">
            <div
              class="showLoaderDiv charts__loader w-full mx-auto"
              style="width: 90%; height: 40%"
              v-if="showLoader"
            >
              <div :class="showLoader ? 'loading' : null"></div>
            </div>
            <div class="chart_m_wrapper" v-if="!showLoader">
              <div class="padding-and-border-radius" style="">
                <highcharts
                  :options="tankReportsSplineOption"
                  class=""
                ></highcharts>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div
              class="empty_tank_wrapper m_table_row"
              style="
                background: white;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-flow: column wrap;
              "
            >
              <div class="text-center" style="margin-top: 20px">
                <h3
                  style="
                    font-size: 21px;
                    font-weight: 500;
                    border-bottom: 1px solid #d3d3d3;
                  "
                  class="pb-3"
                >
                  {{ $t("text.iTankTransactions.tankConsumptionSummary") }}
                </h3>
              </div>

              <div class="animated__tanks__div text-center mt-2">
                <!-- <div class="bowl">
                  <div class="inner">
                      <div class="fill"  v-bind:style="{ '--c': 'blue', '--h': '50px' }">
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="300px"
                       
                        viewBox="0 0 300 300"
                        enable-background="new 0 0 300 300"
                        xml:space="preserve"
                      >
                        <path
                          class="waveShape"
                          d="M300,300V2.5c0,0-0.6-0.1-1.1-0.1c0,0-25.5-2.3-40.5-2.4c-15,0-40.6,2.4-40.6,2.4
                      c-12.3,1.1-30.3,1.8-31.9,1.9c-2-0.1-19.7-0.8-32-1.9c0,0-25.8-2.3-40.8-2.4c-15,0-40.8,2.4-40.8,2.4c-12.3,1.1-30.4,1.8-32,1.9
                      c-2-0.1-20-0.8-32.2-1.9c0,0-3.1-0.3-8.1-0.7V300H300z"
                        />
                      </svg>
                    </div>
                  </div>
                </div> -->

                <div>
                  <ul
                    class="list-group list-group-flush"
                    style="max-height: 160px"
                  >
                    <li
                      class="d-flex justify-content-between align-items-center my-3 w-full"
                      style="font-size: 20px; font-weight: 400"
                    >
                      {{ $t("text.iTankTransactions.volConsumed") }}
                      <span class="ml-2"> {{ totalVolConsumed }}</span>
                    </li>
                    <li
                      class="mb-5 list-group-item d-flex justify-content-between align-items-center w-full"
                      style="font-size: 20px; font-weight: 400"
                    >
                      {{ $t("text.iTankTransactions.volFilled") }}
                      <span class="">{{ totalVolFilled }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="text-cente pb-5" style="margin-top: 50px">
              <h3 style="color: #e8e8e8; font-size: 25px"></h3>
            </div>
          </div>
        </div>
      </section>

      <!-- 
       <section class="mt-3 full__row_section">
         
        </section> -->

      <section class="mt-3 full__row_section">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="40" field="index" headerText="#"></e-column>
            <e-column
              field="date"
              width="180"
              :headerText="$t('text.iTankTransactions.date')"
            ></e-column>
            <e-column
              field="tankName"
              width="180"
              :headerText="$t('text.iTankTransactions.name')"
            ></e-column>
            <e-column
              field="openingDip"
              width="180"
              :headerText="$t('text.iTankTransactions.openingVolume')"
            ></e-column>
            <e-column
              field="closingDip"
              width="180"
              :headerText="$t('text.iTankTransactions.closingVolume')"
            ></e-column>
            <e-column
              field="volumeSold"
              width="180"
              :headerText="$t('text.iTankTransactions.volumeConsumed')"
            ></e-column>
            <e-column
              field="volumeFilled"
              width="180"
              :headerText="$t('text.iTankTransactions.volumeRefilled')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;
export default {
  title: "Tank Transaction:: Epump Industrial Portal",
  name: "Tank Consumption",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: false,
      totalTanks: [],
      volFilled: [],
      totalVolConsumed: 0,
      totalVolFilled: 0,
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(0, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      backImg,
      industryBranch: null,
      industryBranchId: null,
      tankReportsSplineOption: {
        chart: {
          type: "column",
        },
        title: {
          text: this.$t("text.iTankTransactions.tanksReport"),
        },
        xAxis: {
          categories: [],
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t("text.iTankTransactions.totalVolume"),
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getTankReports();
        this.getTotalTanks();
        this.getTankConsumption();
      }
    },
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getTankReports();
        this.getTotalTanks();
        this.getTankConsumption();
      }
    },
  },
  mounted() {
    this.showLoader = true;
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getTotalTanks() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TotalTankSales/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.totalTanks = res.data.totalVolumeConsumed.toFixed(2);
          this.volFilled = res.data.totalVolumeFilled.toFixed(2);
          this.totalVolConsumed = parseFloat(
            res.data.totalVolumeConsumed.toFixed(2)
          );
        });
    },
    getTankReports() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TankSales/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          // this.totalVolConsumed = response.data
          //   .reduce((prev, cur) => Number(prev) + Number(cur.volumeSold), 0)
          //   .toFixed(2);
          this.totalVolFilled = response.data
            .reduce((prev, cur) => Number(prev) + Number(cur.volumeFilled), 0)
            .toFixed(2);
          let series = [];
          var volumeSoldarr = [
            {
              name: this.$t("text.iTankTransactions.volumeConsumed"),
              data: [],
            },
          ];
          var volumeFilledArr = [
            { name: this.$t("text.iTankTransactions.volumeFilled"), data: [] },
          ];
          let cats = [];
          response.data.forEach((el) => {
            volumeSoldarr[0].data.push(parseFloat(el.volumeSold.toFixed(2)));
            volumeFilledArr[0].data.push(parseFloat(el.volumeFilled));
            cats.push(el.tankName);
          });
          this.tankReportsSplineOption.series = [
            ...volumeSoldarr,
            ...volumeFilledArr,
          ];
          this.tankReportsSplineOption.xAxis.categories = cats;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getTankConsumption() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/TankProductSales/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          let index = 0;
          // console.log(response);

          response.data.sort((a, b) => new Date(b.date) - new Date(a.date));
          response.data.forEach((element) => {
            console.log(element.openingDip);
            element.index = ++index;
        element.date = this.$moment(element.date).format("DD/MM/YYYY");
            element.volumeSold = this.convertThousand(element.volumeSold);
            element.volumeFilled = this.convertThousand(element.volumeFilled);
            element.openingDip = this.convertThousand(element.openingDip);
            element.closingDip = this.convertThousand(element.closingDip);
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
